'use client'

import { useEffect, useRef } from 'react'

/**
 * Segler auf Kreisbahn — über der Hero-Section.
 * Nutzt die V5-Silhouette (public/brand/glider.png) als CSS-Mask, Farbe per
 * --glider-color Custom Property. Dadurch pro Farbschema einfach umfärbbar.
 */
export function GliderOrbit({ className = '' }: { className?: string }) {
  const wrapperRef = useRef<HTMLDivElement | null>(null)
  const imgRef = useRef<HTMLDivElement | null>(null)
  const shadowRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const wrap = wrapperRef.current
    const img = imgRef.current
    const shadow = shadowRef.current
    if (!wrap || !img || !shadow) return

    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches

    let raf = 0
    let t = reduce ? 0 : Math.random() * Math.PI * 2

    function frame() {
      t += reduce ? 0 : 0.0045
      const cx = wrap!.clientWidth / 2
      const cy = wrap!.clientHeight * 0.52
      const rx = wrap!.clientWidth * 0.32
      const ry = wrap!.clientHeight * 0.18

      const x = cx + Math.cos(t) * rx
      const y = cy + Math.sin(t) * ry
      const scale = 0.82 + (Math.sin(t) + 1) * 0.18   // weiter hinten kleiner
      // Tangenten-Winkel → Bank-Angle
      const tanX = -Math.sin(t) * rx
      const tanY = Math.cos(t) * ry
      const angle = Math.atan2(tanY, tanX) * (180 / Math.PI)

      img!.style.transform =
        `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%) rotate(${angle * 0.35}deg) scale(${scale})`

      const shadowX = cx + Math.cos(t) * rx
      const shadowScale = 0.7 + (Math.sin(t) + 1) * 0.2
      shadow!.style.transform =
        `translate3d(${shadowX}px, ${wrap!.clientHeight * 0.8}px, 0) translate(-50%, -50%) scaleX(${shadowScale})`
      shadow!.style.opacity = String(0.12 + (Math.sin(t) + 1) * 0.05)

      if (!reduce) raf = requestAnimationFrame(frame)
    }

    frame()
    return () => cancelAnimationFrame(raf)
  }, [])

  return (
    <div
      ref={wrapperRef}
      className={`pointer-events-none relative w-full h-[420px] md:h-[520px] overflow-hidden ${className}`}
      aria-hidden="true"
    >
      {/* Schatten-Ellipse am Horizont */}
      <div
        ref={shadowRef}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: 120,
          height: 10,
          borderRadius: '50%',
          background: 'radial-gradient(ellipse at center, rgba(20,32,42,0.28), transparent 70%)',
          filter: 'blur(6px)',
          willChange: 'transform, opacity',
        }}
      />
      <div
        ref={imgRef}
        className="award-glider"
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: 'min(22vw, 220px)',
          aspectRatio: '3 / 1.1',
          willChange: 'transform',
        }}
      />
    </div>
  )
}
